
import app, { Klass, u_ } from "@@assets/scripts/common";

function createModule(dataKey) {
	return Klass.new_("TyrellModule", dataKey, {
		app,
		apiBaseUrl: app.config.apipath,
		
		// データ配列のフィルタ処理用コールバック（return falseでそのデータを排除）
		itemFilter(i, item) {
			const { category } = item;
			if(category) {
				u_.isObject(this.items.byCategory) || (this.items.byCategory = {});
				const { byCategory } = this.items;
				Array.isArray(byCategory[category]) || (byCategory[category] = []);
				byCategory[category].push(item);
			}
		},
		
		// 設定情報の上書き
		configOverride: {
			// 全件取得
			pageLimit: 0,
		}
	});
}

export default createModule;
